import { useEffect, useState } from "react";

export function useBusinessTheme() {
  const [businessName, setBusinessName] = useState<string>("");

  useEffect(() => {
    const business = sessionStorage.getItem("organization_name") || "";
    setBusinessName(business);

    const themeKeys = [
      { key: "background_color", cssVar: "--background-color" },
      { key: "font_color", cssVar: "--font-color" },
      { key: "font_family", cssVar: "--fontfamily" },
    ];

    themeKeys.forEach(({ key, cssVar }) => {
      const value = sessionStorage.getItem(`${key}${business}`);
      if (value) {
        document.documentElement.style.setProperty(cssVar, value);
      }
    });
  }, []);

  return businessName;
}
